import { Button as MantineButton } from "@mantine/core"
import type { ButtonProps } from "@mantine/core"

type CustomButtonProps = ButtonProps & {
  children: React.ReactNode
  onClick?: () => void
  icon?: React.ReactNode
  type?: "button" | "submit" | "reset"
}

export default function Button(props: CustomButtonProps) {
  return <MantineButton rightSection={props.icon} radius="md" {...props} />
}
